var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep7To6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 44,
    viewBox: "0 0 339 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330.293 11.2929C330.683 10.9024 331.317 10.9024 331.707 11.2929L338.071 17.6569C338.462 18.0474 338.462 18.6805 338.071 19.0711C337.681 19.4616 337.047 19.4616 336.657 19.0711L331 13.4142L325.343 19.0711C324.953 19.4616 324.319 19.4616 323.929 19.0711C323.538 18.6805 323.538 18.0474 323.929 17.6569L330.293 11.2929ZM21 42L311 41.9999L311 43.9999L21 44L21 42ZM330 22.9999L330 12L332 12L332 22.9999L330 22.9999ZM3.88625e-06 23L0 5.78739e-05L2 5.75242e-05L2 23L3.88625e-06 23ZM311 41.9999C321.493 41.9999 330 33.4934 330 22.9999L332 22.9999C332 34.5979 322.598 43.9999 311 43.9999L311 41.9999ZM21 44C9.40205 44 5.84594e-06 34.598 3.88625e-06 23L2 23C2.00001 33.4934 10.5066 42 21 42L21 44Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep7To6);
export default __webpack_public_path__ + "static/media/step_7_to_6.9ff1131eb86fdb8d0b17272b5246e997.svg";
export { ForwardRef as ReactComponent };